import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { PropertyDocuments } from '../../../shared/models/propertydetails';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../../../shared/auth/auth.service';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { IEditDocumentModel } from '../../../shared/models/EditDocumentModel';
import { OnDestroy } from '@angular/core';

interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}

@Component({
  selector: 'app-portfolio-files',
  templateUrl: './portfolio-files.component.html',
  styleUrls: ['./portfolio-files.component.css']
})
export class PortfolioFilesComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  //defaultCategoryText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Category',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Filter By Category",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  //defaultCategoryText1: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Property',
  //};
  defaultTypeSettings1 = {
    singleSelection: false,
    text: "Filter By Property",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  propertyDocuments: PropertyDocuments[] = [];
  constructor(private _toastService: ToastService, public Validation: ValidationService, private modalService: BsModalService, private _propertyDetails: PropertyManagementService, private http: HttpClient, public authentication: AuthenticationService, private _userManagerService: UserManagerService, private Loader: LoaderService, private _auth0: AuthService, private router: Router, private _dashboardService: DashboardService) {
  }
  user: any;
  DDColumns = [];
  categoryids = [];
  dtoptions = {};
  categoryLst = [];
  propertyLst = [];
  IsLoading = false;
  selectedpropertyIds = [];
  propertyIdsPortfolio = [];
  propertyIds = [];
  editProperty: number;
  noDataShow: number = 0;
  documentPreview: BsModalRef;
  modalRefDelete: BsModalRef;
  modalRefEdit: BsModalRef;
  fileName: string;
  docPreview: any;
  @Input() source: 'MyPortfolio';
  @Input() propertyId: number = 0;
  @Input() BackgroundFileStoring: number = 0;
  @Input() UserGuid: string;
  subscription: Subscription = new Subscription();
  modalRef: BsModalRef;
  subscriptions: Subscription[] = [];
  showfile: number = 0;
  editDocumentModel = {} as IEditDocumentModel;
  isInitialLoad: boolean = false;
  protected readonly BASE_URL: string = environment.base_url;
  ngOnInit() {
    this.isInitialLoad = true;
    this.UserGuid = this.UserGuid != '' && this.UserGuid != undefined && this.UserGuid != null ? this.UserGuid : '0000';
    this.user = this.authentication.user;
    this.loadDDCategoryTypes();
    this.loadPrincipalProperties();
    this.loadPropertyFiles();

    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(f => f.ImageStatus == '' || f.ImageStatus == null && f.sourceUrl == this.router.url && f.RefreshTab == 'MyPortfolio-Files');
      if (ongoingList != null && ongoingList.length > 0) {
        localStorage.setItem('currentFileRefreshTab', 'MyPortfolio-Files');
      }
      else if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
    }

    this.subscription.add(this._auth0.customObservable.subscribe((res) => {
      if (res.sourceUrl == this.router.url && localStorage.getItem('currentFileRefreshTab') == 'MyPortfolio-Files' && res.refreshTab == 'MyPortfolio-Files') {
        /*localStorage.removeItem('currentFileRefreshTab');*/
        this.redrawTable();
      }
    }
    ));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    });
  }

  refreshFiles($event) {
    //// this.getDocuments();
    this.redrawTable();
    this.loadDDCategoryTypes();
    this.loadPrincipalProperties();
  }

  redrawTable() {
    this.propertyIds = [];
    this.propertyIdsPortfolio = [];

    if (this.selectedpropertyIds != null && this.selectedpropertyIds.length > 0) {
      this.selectedpropertyIds.forEach(element => {
        let currentItem = this.propertyLst.find(f => f.id == element);
        if (currentItem != null) {
          if (currentItem.Type == 'Property') {
            this.propertyIds.push(element);
          }
          else {
            this.propertyIdsPortfolio.push(element);
          }
        }
      });
    }
    if (!this.isInitialLoad) {
      this.dtElement.dtInstance.then(x => x.draw(false));
    }
  }

  categoryId: number;
  UpdateDocCategory() {
    this.editDocumentModel.PropertyId = this.editProperty;
    this.editDocumentModel.CategoryId = this.categoryId;
    this.editDocumentModel.UserId = this.user.Id;
    this.editDocumentModel.DocumentId = this.editFileId;
    this.editDocumentModel.IsActive = true;
    this.editDocumentModel.UserGuid = this.UserGuid;

    if (this.editDocumentModel.PropertyId == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: "Please Select Property / Portfolio", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      return;
    }

    if (this.editDocumentModel.PropertyId == -1) {
      this.editDocumentModel.PropertyId = 0;
    }
    this._dashboardService.EditDocument(this.editDocumentModel).subscribe(res => {
      this.modalRefEdit.hide();
      this.dtElement.dtInstance.then(x => x.draw(false));
      this._toastService.addToast({ title: 'Success', msg: 'Document updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    })
  }

  loadDDCategoryTypes() {
    this.subscriptions.push(this._propertyDetails.getFileCategories(6805).subscribe(response => {
      this.categoryLst = response.map(o => {
        return { id: o.Id, name: o.Description };
      });
    }));
  }
  onSearch(text: string) {
    ;
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  loadPropertyFiles() {

    this.DDColumns = [
      { data: 'Name', orderable: false },
      { data: 'Name', orderable: false },
      { data: 'Name', orderable: false },
      { data: 'Document Title', orderable: false },
      { data: 'Category' },
      { data: 'Uploaded By', orderable: false },
      { data: 'Date' },
    ]

    if (this.source != 'MyPortfolio') {
      this.DDColumns = [
        { data: 'Name', orderable: false },
        { data: 'Name', orderable: false },
        { data: 'Document Title', orderable: false },
        { data: 'Category' },
        { data: 'Uploaded By', orderable: false },
        { data: 'Date' },
      ]
    }
    if (this.selectedpropertyIds != null && this.selectedpropertyIds.length > 0) {
      this.selectedpropertyIds.forEach(element => {
        if (this.propertyLst.findIndex(f => f.Id == element) > -1) {
          let currentItem = this.propertyLst.find(f => f.Id == element)
          if (currentItem != null) {
            if (currentItem.Type == 'Property') {
              this.propertyIds.push(element);
            }
            else {
              this.propertyIdsPortfolio.push(element);
            }
          }
        }
      });
    }
    const orderId = this.source != 'MyPortfolio' ? 5 : 6;
    const that = this;
    const Pagesource = this.source;
    this.noDataShow = 1;
    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      stateSave: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[orderId, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          DocumentCategories: that.categoryids,
          IsDataEntryProperty: false,
          PropertyId: Pagesource == 'MyPortfolio' ? 0 : this.propertyId,
          PropertyLst: that.propertyIds,
          PortfolioLst: that.propertyIdsPortfolio
        }

        this.subscriptions.push(that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/GetPortfolioFileList/' + this.user.Id + '/' + this.UserGuid, dataTablesParameters).subscribe(resp => {
            if (resp != null) {
              this.propertyDocuments = resp.data ? resp.data : [];
              this.isInitialLoad = false;
              this.Loader.display(false);
              this.noDataShow = 0;
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              this.noDataShow = 0;
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          }));
        this.Loader.display(false);
      },
      columns: that.DDColumns
    };
  }
  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  docId = 0;
  onRemoveDocument() {
    var input = [];
    input.push(this.docId);
    this._propertyDetails.deleteMyPortfolioDocument(this.docId, this.user.Id).subscribe(response => {
      this._toastService.addToast({
        title: 'Delete',
        msg: `Deleted Successfully`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.modalRefDelete.hide();
      this.redrawTable()
      this.loadDDCategoryTypes();
    });
  }

  openDeleteModal(template: TemplateRef<any>, classes: any, id: number) {
    this.docId = id;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }

  editFileId: number;

  openEditModal(template: TemplateRef<any>, classes: any, id: number, category: number, objectId: number, objectTypeId: number = 0, fileName: string) {
    this.editProperty = objectTypeId==324 ? -1: objectId;
    this.categoryId = category;
    this.editFileId = id;
    this.fileName = fileName;
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  loadPrincipalProperties() {
    this.subscriptions.push(this._propertyDetails.getPrincipalPortfolioProperties(this.user.Id, this.UserGuid, '0000').subscribe(response => {
      if (response != null && response.length > 0) {
        this.propertyLst = response.map(o => {
          return { id: o.Id, name: o.PropertyName, Type: o.PropertyType };
        });
      }
    }));
  }

  OpenAddUserSlider(template: TemplateRef<any>, classes: any, sourceType: string) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }
}

